<template>
  <div class="c-scenario">
    <div class="c-scenario__left">
      <panel-header
        title="Визуализация расчета"
        :with-back-button="true"
        @back="back"
      />
      <div class="c-scenario__container" v-loading="loading">
        <div class="c-scenario__title">
          <el-input class="r-input" v-model="currentScenarioName" disabled />
          <el-button
            style="margin-left: 8px; width: auto"
            :loading="deleting"
            circle
            type="danger"
            class="r-button icon-button"
            size="mini"
            @click="deleteScenario"
          >
            <r-icon name="trash" type="additional" :size="16" />
          </el-button>
        </div>
        <div class="c-scenario__layers">
          <r-text type="caption" style="margin-bottom: 8px;">
            Список слоев
          </r-text>
          <layers-list />
        </div>
        <div v-if="calculation" class="c-scenario__calc-info">
          <calculation-info :calculation="calculation" />
        </div>
      </div>
    </div>
    <div class="c-scenario__right" v-if="settingsId">
      <layer-settings />
    </div>
  </div>
</template>

<script>
import PanelHeader from "@/components/calculations/panel-header/panel-header";
import LayersList from "@/components/calculations/layers-list/layers-list";
import LayerSettings from "@/components/calculations/layer-settings/layer-settings";
import CalculationInfo from "@/components/calculations/calculation/calculation-info";

export default {
  components: {
    PanelHeader,
    LayersList,
    LayerSettings,
    CalculationInfo
  },
  data() {
    return {
      loading: false,
      deleting: false,
      calculation: null
    };
  },
  computed: {
    currentScenarioId() {
      return this.$store.state.calculations.currentScenarioId;
    },
    currentScenarioName() {
      return this.$store.state.calculations.currentScenarioName;
    },
    settingsId() {
      return this.$store.state.calculations.settingsId;
    }
  },
  methods: {
    back() {
      if (this.$store.state.calculations.loadingLayers.length) return;
      const { modelId } = this.$route.params;

      this.$store.commit("SET_CALC_FIELD", {
        field: "currentScenarioId",
        value: null
      });
      this.$store.commit("SET_CALC_FIELD", {
        field: "currentScenarioName",
        value: null
      });

      this.$router.push(`/app/calculations/${modelId}/list`);
    },
    async getData() {
      try {
        this.loading = true;

        // get calculation data
        const { modelId } = this.$route.params;
        const branchResponse = await this.$store.dispatch("REQUEST", {
          url: `branch/${modelId}`
        });

        this.calculation = branchResponse.data.calculation;

        // get times data
        const { ids } = this.$store.state.calculations.model;
        const id = ids["link_calculation_results"];
        const { scenarioId } = this.$route.params;
        const config = {
          unique_values: "time_value",
          where: [
            {
              field: "calculation_id",
              op: "=",
              value: scenarioId
            }
          ]
        };
        const url = `objectInfo/${id}?config=${JSON.stringify(config)}`;

        const { data } = await this.$store.dispatch("REQUEST", { url });
        const times = data.length === 1 ? null : data;

        if (times) {
          this.$store.commit("SET_CALC_FIELD", {
            field: "times",
            value: times
          });
          this.$store.commit("SET_CALC_FIELD", {
            field: "currentTime",
            value: times[0]
          });
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    async deleteScenario() {
      try {
        this.deleting = true;

        const source_id = this.$store.state.calculations.model.id;
        const url = `branch?id=${this.currentScenarioId}`;
        await this.$store.dispatch("DELETE_REQUEST", { url });

        this.deleting = false;
        this.$router.push(`/app/calculations/${source_id}/list`);
      } catch (error) {
        console.log(error);
        this.deleting = false;
      }
    }
  },
  created() {
    this.getData();
  },
  beforeDestroy() {
    this.$store.commit("SET_CALC_FIELD", {
      field: "settingsId",
      value: null
    });
  }
};
</script>

<style lang="scss">
.c-scenario {
  height: calc(100vh - 48px);
  display: flex;

  &__left {
    display: flex;
    flex-direction: column;
    width: 260px;
  }

  &__right {
    display: flex;
    flex-direction: column;
    width: 260px;
    background-color: var(--bg_panel_secondary) !important;
  }

  &__container {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 0px;
  }

  &__title {
    display: flex;
    align-items: center;
    padding: 8px;
    border-bottom: 1px solid transparent;
    border-color: var(--dividers_low_contrast) !important;
  }

  &__layers {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 8px;
  }

  &__calc-info {
    padding: 8px;
  }
}
</style>
